module.exports = __webpack_public_path__ + "img/pet_winning.165169e1.png";